<div class="widget-mobile">
  <div class="container pt-4">
    <div class="d-none d-lg-block pt-3 mb-4">
      <div class="back-button" [routerLink]="'/rewards/wallet'">
        <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
      </div>
    </div>

    <fgbcl-marketplace-wallet-details [id]="id"></fgbcl-marketplace-wallet-details>
  </div>
</div>
